import { useState } from "react";

import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import { dataValidator } from "../../tools/dataValidator";

import { getLabel } from "../../tools/Dictionary";

const ConditionDesignerTableVariable = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const OnCloseModal = props.OnCloseModal;
  const OnConfirm = props.OnConfirm;
  const Variable = props.Variable;
  const VariableName = props.VariableName;
  const Condition = props.Condition;

  //State
  const [form, setForm] = useState({
    variable: undefined,
    rowFind: undefined,
    rowReturn: undefined
  });
  const [column, setColumn] = useState([]);
  const [error, setError] = useState({

  });
  const [loading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  useMount(() => {

    if (Condition && Condition.tableVariable){

      setForm({
        variable: Condition.tableVariable,
        variableName: Condition.tableVariableName,
        rowFind: Condition.rowFind,
        rowReturn: Condition.rowReturn    
      });


      let currentTable = Variable.find(v => v._id == Condition.tableVariable);

      setColumn(currentTable.data.column);

    }

  }, []);



  const onChangeVariable = (e) => {

    try{

      let currentTable = Variable.find(v => v._id == e.target.value);

      setForm(form => ({
        variable: e.target.value,
        variableName: currentTable.name,
        rowFind: 0,
        rowReturn: 0
      }));


      setColumn(currentTable.data.column);

    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    }


  }

  const onChangeFind = (e) => {

    setForm(form => ({
      ...form,
      rowFind: e.target.value,
    }));


  };

  const onChangeReturn = (e) =>
  {

    setForm(form => ({
      ...form,
      rowReturn: e.target.value,
    }));


  };


  // Validate field
  const onValidateField = (field = "", value = "") =>
  {
    let currentError = { ...error }; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];
    let currentField = "";

    let isValid = true; // Flag to track overall validity

    currentField = "variable";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    currentField = "rowFind";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    currentField = "rowReturn";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag
  };


  const onClickDelete = () => {

    setConfirm(confirm => ({
      Title: getLabel("App", "Delete"),
      Message: getLabel("App", "Are you sure you want to delete this entity?"),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: onDelete,
      Display: true
    }));

  };

  const onDelete = () => {


    OnConfirm({
      variable: undefined,
      variableName: undefined,
      rowFind: undefined,
      rowReturn: undefined
    });

  };


  const onConfirm = () => {

    try
    {

      if (!onValidateField()) throw new Error(getLabel("App", "The form contains errors. Please check and fix the fields highlighted in red."));



      OnConfirm(form);

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });




    }

  };


  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "700px", minHeight: "0px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ConditionDesigner", "Conversion")}
        </div>
        <div className="page_modal_body_cont" style={{minHeight: "100px", paddingBottom: "30px"}}>
          <div className="conditiondesigner_conversion_row">
            <div className="conditiondesigner_conversion_row_group_left">
              <div className="conditiondesigner_conversion_row_label">
                {getLabel("ConditionDesigner", "Convert")}
              </div>
              <div className="conditiondesigner_conversion_variablename">
                {VariableName}
              </div>
            </div>
            <div className="conditiondesigner_conversion_row_group_right">
              <div className="conditiondesigner_conversion_row_label">
                {getLabel("ConditionDesigner", "using")}
              </div>
              <select
                value={form.variable}
                className={"page_select_input " + (error["variable"] ? "page_select_error " : "")}
                onChange={onChangeVariable}
                style={{ width: "300px", textAlign: "center", color: "black" }}
              >
                <option value style={{ textAlign: "center" }}>{getLabel("ConditionDesigner", "Choose a variable")}...</option>
                {Variable.map((v, index) => (
                  <option key={index} value={v._id} style={{ textAlign: "center", color: "black" }}>
                    {v.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {form.variable &&
            <div className="conditiondesigner_conversion_row">
              <div className="conditiondesigner_conversion_row_group_left">
                <div className="conditiondesigner_conversion_row_label">
                  {getLabel("ConditionDesigner", "find in column")}
                </div>
                <select
                  value={form.rowFind}
                  className={"page_select_input " + (error["rowFind"] ? "page_select_error " : "")}
                  onChange={onChangeFind}
                  style={{ width: "300px", textAlign: "center", color: "black" }}
                >
                  {column.map((c, index) => (
                    <option key={index} value={index} style={{ textAlign: "center", color: "black" }}>
                      {c}
                    </option>
                  ))}
                </select>
              </div>
              <div className="conditiondesigner_conversion_row_group_right">
                <div className="conditiondesigner_conversion_row_label">
                  {getLabel("ConditionDesigner", "and return column")}
                </div>
                <select
                  value={form.rowReturn}
                  className={"page_select_input " + (error["rowReturn"] ? "page_select_error " : "")}
                  onChange={onChangeReturn}
                  style={{ width: "300px", textAlign: "center", color: "black" }}
                >
                  {column.map((c, index) => (
                    <option key={index} value={index} style={{ textAlign: "center", color: "black" }}>
                      {c}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          }
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          {Access.canWrite &&
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Delete")}
            style={{ maxWidth: "200px", backgroundColor: "#b30000" }}
              onClick={onClickDelete}
              disabled={loading}
            />
          }
          {Access.canWrite && 
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Confirm")}
              style={{ maxWidth: "200px" }}
              onClick={onConfirm}
              disabled={loading}
            />
          }
          
        </div>
      </div>
    </div>
  );

};

export default ConditionDesignerTableVariable